const TEST_IDS_EXTERNAL_VIEWS = {
  breadcrumb: 'breadcrumb',
  dropdownItem: 'dropdown-item',
  dropdownOption: 'dropdown-option',
  iframe: {
    inbox: 'iframe-inbox',
    kanban: 'iframe-kanban',
    list: 'iframe-list',
    report: 'iframe-report',
    root: 'iframe',
  },
  iframeTitle: 'iframe-title',
  newButton: 'new-button',
  pillTab: 'pill-tab',
  sidebar: {
    accountingsTab: 'sidebar-accountings',
    buyingTab: 'sidebar-buying',
    hrTab: 'sidebar-hr',
    marketingTab: 'sidebar-marketing',
    moduleSettingsLink: 'sidebar-module-settings-link',
    projectTab: 'siedebar-project',
    routerLink: 'sidebar-router-link',
    salesTab: 'sidebar-sales',
    servicesTab: 'sidebar-services',
    settingsTab: 'sidebar-settings',
    stockTab: 'sidebar-stock',
  },
  tabBar: 'tab-bar',
}

export { TEST_IDS_EXTERNAL_VIEWS }
